<script lang="ts" setup>
import type { Team } from '~/store/localGameStore'

const props = defineProps<{
  homeTeam: Team
  visitorTeam: Team
  homeTeamStarterId: number | null
  visitorTeamStarterId: number | null
  onConfirm: (player_1_starter_id: number, player_2_starter_id: number) => void
}>()

const emit = defineEmits<{ close: [] }>()

const home_team_player_1_id = ref<number | null>(props.homeTeamStarterId)
const visitor_team_player_1_id = ref<number | null>(props.visitorTeamStarterId)

const confirm = () => {
  if (home_team_player_1_id.value === null || visitor_team_player_1_id.value === null) {
    alert('Please select a starting player')
    return
  }
  props.onConfirm(home_team_player_1_id.value, visitor_team_player_1_id.value)
  emit('close')
}
</script>

<template>
  <UiDialog :open="true">
    <UiDialogContent
      :title="$t('Set team starting player')"
      disable-outside-pointer-events
      @pointer-down-outside="($event) => $event.preventDefault()"
    >
      <UiAlert
        variant="warning"
        :title="$t('The starting player is the player who will always throw first in every leg!')"
        :description="$t('This cannot be changed once the match is started.')"
      />
      <div class="flex flex-col gap-8 items-center w-full">
        <div class="flex flex-col gap-2 items-center w-full">
          {{ homeTeam.players[0].name }} & {{ homeTeam.players[1].name }}
          <UiToggleGroup
            v-model="home_team_player_1_id"
            variant="outline"
            class="w-full"
            size="lg"
          >
            <UiToggleGroupItem
              v-for="player in homeTeam.players"
              :key="player.id"
              :value="player.id"
              class="text-2xl"
            >
              {{ player.name }}
            </UiToggleGroupItem>
          </UiToggleGroup>
        </div>
        <div class="flex flex-col gap-2 items-center">
          {{ visitorTeam.players[0].name }} & {{ visitorTeam.players[1].name }}
          <UiToggleGroup
            v-model="visitor_team_player_1_id"
            variant="outline"
            class="w-full"
            size="lg"
          >
            <UiToggleGroupItem
              v-for="player in visitorTeam.players"
              :key="player.id"
              :value="player.id"
              class="text-2xl"
            >
              {{ player.name }}
            </UiToggleGroupItem>
          </UiToggleGroup>
        </div>
      </div>
      <template #footer>
        <UiButton
          variant="secondary"
          :text="$t('Cancel')"
          class="mr-auto"
          size="huge"
          @click="emit('close')"
        />
        <UiButton
          :disabled="!home_team_player_1_id || !visitor_team_player_1_id"
          :text="$t('Confirm')"
          variant="success"
          size="huge"
          @click="confirm"
        />
      </template>
    </UiDialogContent>
  </UiDialog>
</template>
